import * as Constants from '../constants/actions';
import { PUBLICATIONS } from '../constants/api';
import axios from 'axios';

/**
 * @name getPublications
 * @function
 * @returns {function}
 * @description Retrieves user's list of Publications
 */
export const getPublications = () => {
    return dispatch => {
        axios.get( PUBLICATIONS )
        .then( resPublications => {
            dispatch({ type: Constants.GET_PUBLICATIONS, payload: { publications: resPublications.data } });
        })
        .catch( err =>  dispatch({ type: Constants.GET_PUBLICATIONS, payload: { err } }) );
    }
}

/**
 * @name sortPublications
 * @function 
 * @description sort the Publications
 * @param {Array} publications Publications array
 * @param {number|string} sortType determine the sort type
 */
export const sortPublications = ( publications, sort ) => {
    return dispatch => dispatch({ type: Constants.SORT, payload: { publications, sort } });
}

/**
 * @name filterPublications
 * @function 
 * @description filter the Publications
 * @param {Array} publications Publications array
 * @param {number|string} filter determine the filter
 */
export const filterPublications = ( publications, filter ) => {
    return dispatch => dispatch({ type: Constants.FILTER, payload: { publications, filter } });
}